//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "BowSkeleton",
    props: {
        effect: {
            default: null,
            type: String,
        },
        htmlTag: {
            default: null,
            type: String,
        },
        type: {
            default: "block",
            type: String,
        },
    },
    data: () => ({}),
};
